import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Empty, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PostCard from '../../components/PostCard';
import { getPosts } from '../../api/mockData';
import './index.css';

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPosts();
  }, [page]);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const data = await getPosts(page);
      if (page === 1) {
        setPosts(data);
      } else {
        setPosts(prev => [...prev, ...data]);
      }
      setHasMore(data.length > 0);
    } catch (error) {
      console.error('获取文章失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = () => {
    setPage(prev => prev + 1);
  };

  const handleWritePost = () => {
    navigate('/write');
  };

  if (loading && page === 1) {
    return (
      <div className="home-loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="home-container">
      <div className="home-header">
        <h1 className="home-title">最新文章</h1>
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          onClick={handleWritePost}
          className="write-post-btn"
        >
          写文章
        </Button>
      </div>

      {posts.length === 0 ? (
        <Empty
          description="暂无文章"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          className="home-empty"
        >
          <Button type="primary" onClick={handleWritePost}>
            开始写作
          </Button>
        </Empty>
      ) : (
        <>
          <Row gutter={[24, 24]} className="posts-grid">
            {posts.map(post => (
              <Col 
                key={post.id} 
                xs={24} 
                sm={12} 
                lg={8}
              >
                <PostCard post={post} />
              </Col>
            ))}
          </Row>

          {hasMore && (
            <div className="load-more">
              <Button 
                type="default" 
                loading={loading} 
                onClick={loadMore}
                block
              >
                {loading ? '加载中...' : '加载更多'}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Home;